import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LayoutGlobalManagementHeaderVisibilityService {
  private customerVisibleSubject = new BehaviorSubject<boolean>(false);
  private gyosekiManagementVisibleSubject = new BehaviorSubject<boolean>(false);

  customerVisible$ = this.customerVisibleSubject.asObservable();
  gyosekiManagementVisible$ = this.gyosekiManagementVisibleSubject.asObservable();

  public toggleGlobalCustomerHeader() {
    const current = this.customerVisibleSubject.getValue();
    this.customerVisibleSubject.next(!current);
    this.gyosekiManagementVisibleSubject.next(false);
  }

  public toggleGlobalGyosekiManagementHeader() {
    const current = this.gyosekiManagementVisibleSubject.getValue();
    this.gyosekiManagementVisibleSubject.next(!current);
    this.customerVisibleSubject.next(false);
  }
}
